import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { useOrderItemsModule } from '../../../OrderForm/contexts/OrderItemsModuleContext'
import { buildOrderPayload } from '../api'
import { useOrderItems } from '../contexts/OrderItemsContext'
import type { FashionOrderFormValues } from '../fashionOrder.schema'

interface FashionOrderSaveBridgeProps {
  target?: React.MutableRefObject<() => void | Promise<void>>
  fileIds: number[]
  submit: (payload: ReturnType<typeof buildOrderPayload>) => Promise<void>
  onGuardFailure: (message: string) => void
  onInvalid: () => void
}

/**
 * Registra o save no botão do layout. Monta o payload aqui dentro porque depende do form e dos
 * itens, e nenhum dos dois existe acima desta árvore.
 */
const FashionOrderSaveBridge: React.FC<FashionOrderSaveBridgeProps> = ({
  target, fileIds, submit, onGuardFailure, onInvalid,
}) => {
  const { getValues, handleSubmit } = useFormContext<FashionOrderFormValues>()
  const { validateBeforeSave } = useOrderItemsModule()
  const { addedProducts } = useOrderItems()

  useEffect(() => {
    if (!target) return
    target.current = async () => {
      const guard = validateBeforeSave()
      if (!guard.ok) {
        onGuardFailure(guard.message)
        throw new Error(guard.message)
      }

      let actionError: unknown = null
      let didRun = false
      await handleSubmit(
        async () => {
          didRun = true
          try {
            /** valores crus, não a saída do resolver: o zod faria strip dos campos extras dos selects */
            await submit(buildOrderPayload(getValues(), addedProducts, fileIds))
          } catch (err) {
            actionError = err
          }
        },
        onInvalid,
      )()
      if (actionError) throw actionError
      if (!didRun) throw new Error('Formulário inválido')
    }
  }, [target, getValues, handleSubmit, validateBeforeSave, addedProducts, fileIds, submit, onGuardFailure, onInvalid])

  return null
}

export default FashionOrderSaveBridge
